import React, { Component } from 'react';
import Profilecomponent from '../../common/profilecomponent';
import CatalogoCobroContainer from './CatalogoCobroContainer';
import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import CreateCatalogoCobroContainer from "./CreateCatalogoCobroContainer";

import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import { Link } from "react-router-dom";


const mapStateToProps = (state) => {

	state.CatalogoCobroReducer.getResponDataCatalogoCobro	= false;
	state.CatalogoCobroReducer.errorResponDataCatalogoCobro = false;
	state.CatalogoCobroReducer.getCatalogoCobroDetail		= false;
	state.CatalogoCobroReducer.errorCatalogoCobroDetail		= false;
	state.CatalogoCobroReducer.getResponDataCatalogoCobroC	= false;
	state.CatalogoCobroReducer.errorResponDataCatalogoCobroC= false;
	state.CatalogoCobroReducer.getCatalogoCobroBorrar		= false;
	state.CatalogoCobroReducer.errorCatalogoCobroBorrar		= false;
	state.CatalogoCobroReducer.getCatalogoCobroActivar		= false;
	state.CatalogoCobroReducer.errorCatalogoCobroActivar	= false;

	return {
		getResponDataCatalogoCobro: state.CatalogoCobroReducer.getResponDataCatalogoCobro,
		errorResponDataCatalogoCobro: state.CatalogoCobroReducer.errorResponDataCatalogoCobro,
		getCatalogoCobroDetail: state.CatalogoCobroReducer.getCatalogoCobroDetail,
		errorCatalogoCobroDetail: state.CatalogoCobroReducer.errorCatalogoCobroDetail,
		getResponDataCatalogoCobroC: state.CatalogoCobroReducer.getResponDataCatalogoCobroC,
		errorResponDataCatalogoCobroC: state.CatalogoCobroReducer.errorResponDataCatalogoCobroC,
		getCatalogoCobroBorrar: state.CatalogoCobroReducer.getCatalogoCobroBorrar,
		errorCatalogoCobroBorrar: state.CatalogoCobroReducer.errorCatalogoCobroBorrar,
		getCatalogoCobroActivar: state.CatalogoCobroReducer.getCatalogoCobroActivar,
		errorCatalogoCobroActivar: state.CatalogoCobroReducer.errorCatalogoCobroActivar,
	};
};


class CatologoCobro extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

	render() {
		const { activeTab } = this.state
		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Servicios</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Administrativo</a></li>
									<li className="breadcrumb-item active" aria-current="page">Servicios</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								
								<NavItem>
									<Link
										to={"/crearcatalogocobro"}
										className={classnames({ active: activeTab === 3 })}
										onClick={() => this.setState({ activeTab: 3 })}
									>
										Agregar
    			               </Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								<CatalogoCobroContainer />
							</TabPane>

						</TabContent>
					</div>
				</div>

			</>
		);

	}//END RENDER


}//END CLASS

export default withRouter(connect(mapStateToProps, null)(CatologoCobro));

